import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain" style={{ background: "var(--onyx)" }} data-testid="login-page">
      <div className="absolute top-6 left-6">
        <Link to="/" className="overline" style={{ color: "var(--champagne)" }} data-testid="back-home-link">
          ← BEAUTWELLZ
        </Link>
      </div>
      <div className="w-full max-w-md p-10" style={{ border: "1px solid rgba(247,245,240,0.18)", background: "rgba(247,245,240,0.02)" }}>
        <div className="overline mb-3" style={{ color: "var(--champagne)" }}>Admin Access</div>
        <h1 className="font-serif-display text-[42px] leading-tight" style={{ color: "var(--ivory)" }}>
          Investor<br /><em style={{ color: "var(--champagne)" }}>Dashboard.</em>
        </h1>
        <p className="mt-3 text-[13px]" style={{ color: "rgba(247,245,240,0.6)" }}>
          Restricted to BEAUTWELLZ admin. Sign in to view enquiries &amp; generate the investor PDF.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
          <div>
            <label className="overline" style={{ fontSize: 10, color: "rgba(247,245,240,0.6)" }}>Email</label>
            <div className="flex items-center gap-3 mt-1" style={{ borderBottom: "1px solid rgba(247,245,240,0.25)" }}>
              <Mail size={16} style={{ color: "var(--champagne)" }} />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent py-2.5 text-[15px] focus:outline-none"
                style={{ color: "var(--ivory)", fontFamily: "Outfit" }}
                placeholder="humera.rindani@beautywellness.in"
                data-testid="login-email"
              />
            </div>
          </div>

          <div>
            <label className="overline" style={{ fontSize: 10, color: "rgba(247,245,240,0.6)" }}>Password</label>
            <div className="flex items-center gap-3 mt-1" style={{ borderBottom: "1px solid rgba(247,245,240,0.25)" }}>
              <Lock size={16} style={{ color: "var(--champagne)" }} />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent py-2.5 text-[15px] focus:outline-none"
                style={{ color: "var(--ivory)", fontFamily: "Outfit" }}
                placeholder="••••••••••••"
                data-testid="login-password"
              />
            </div>
          </div>

          {err && (
            <div className="text-[13px]" style={{ color: "#e89191" }} data-testid="login-error">{err}</div>
          )}

          <button
            type="submit"
            disabled={busy}
            className="btn-primary btn-onyx w-full justify-center mt-4"
            data-testid="login-submit"
          >
            {busy ? "Signing in..." : "Sign In"} <ArrowRight size={14} />
          </button>
        </form>

        <div className="mt-8 text-[11px]" style={{ color: "rgba(247,245,240,0.4)", fontFamily: "Outfit", letterSpacing: "0.12em", textTransform: "uppercase" }}>
          Authorised personnel only · All access is logged
        </div>
      </div>
    </div>
  );
}
